import {BaseMuWidget} from "../BaseMuWidget";
import {PqmIOputData, PqmPacket, PqmProcData, PqmProcDataField, PqmProcDataFields} from "./pqmTypes";
import {TreeView} from "../components/TreeView";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {BasePqmFieldValue} from "./Fields/BasePqmFieldValue";
import {PqmFieldRegister} from "./Fields/PqmFieldRegister";
import {changeClassStartsWith, changeIconBefore, sleepPromise} from "../Utils";
import {PqmPackets} from "./PqmPackets";

export class PqmField extends BaseMuWidget
{
	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		conditions: TreeView
	}>

	// @ts-ignore
	muParent: PqmPackets;

	// @ts-ignore
	public fieldWidget: BasePqmFieldValue|null = null;

	// @ts-ignore
	public pqmPacketData: PqmPacket;

	public disabled: boolean = false;
	private requireCompletion: boolean = false;

	public setDisabled(disabled: boolean): void
	{
		this.ui.isComplete.disabled = disabled;
		this.fieldWidget?.setDisabled(disabled);
	}

	public setRejectVisible(visible: boolean) {
		// this.muVisible(visible, 'lReject');
	}

	beforeIndex() {
		this.container.classList.add("row");
		this.muAppendContent(`
			<label class="col-sm-3 control-label" mu="label">
				<label class="checkbox-icon" mu="lIsComplete"><input type="checkbox" mu="isComplete#isComplete" /><span></span></label>
				<span mu="isCompleteIndicator#isCompleteIndicator" class="pqm-packet-complete-indicator"></span>
				<label class="checkbox-invalid-input" mu="lReject" style="display: none">
					<input type="checkbox" mu="reject#requireCompletion;requireCompletion:disabled" /><span></span>
				</label>
				<span mu="name#name"></span>
			</label>
			<div mu="shiftDetails" class="col-sm-3"></div>
			<div class="col-sm-9">
				<div mu="pInput"></div>
				<div mu="details">
					<div mu="conditionsContainer" class="toggleable-details">
						<strong>Podmínky</strong>
						<ul mu="conditions:TreeView">
							<li mu=":.@item">
								<span mu-bind="name"></span> <em mu-bind="description"></em>
								<ul mu="children"></ul>
							</li>
						</ul>
					</div>
					<div mu="cooperatingContainer" class="toggleable-details">
						<strong mu="cooperatingLabel"></strong>
						<ul mu="#cooperating:@foreach">
							<li mu=":.@cooperatingItem">
								<a mu=":PqmTicketLink#ticketId:.ticketId;evidenceUid:innerText;ticket"></a>
								<a mu=":PqmTicketLink#ticketId:.ticketId;summary:innerText;ticket"></a>
								<span mu-bind="stateName;stateColor:style.backgroundColor;stateColor|bwContrasted:style.color" class="badge"></span>
								<span mu-bind="solvers:@foreach">
									<span mu=":AccountLink@solverItem#accountName:.accountName;accountId:.accountId;accountId"></span>
								</span>
							</li>
						</ul>					
					</div>
				</div>
			</div>
		`);

	}

	protected get packets(): PqmPackets {
		return this.muParent.muParent as unknown as PqmPackets;
	}

	reject_change() {
		this.packets.updateRejected();
	}

	muBindData(srcData: PqmPacket&{plunge:number}) {
		super.muBindData(srcData);
		this.pqmPacketData = srcData;
		this.ui.label.style.paddingLeft = ((srcData.plunge + 1) * 1.5).toString() + "rem";
		const conditions = (this.getPropertyInAncestors('packetsData') as PqmIOputData)
			.conditions[srcData.pqmPacketId];
		if (conditions) {
			this.muNamedWidget.conditions.render(
				conditions,
				{
					srcStructFormat: "parentField",
					outStructType: "plunge",
				}
			)
		}
		const cooperating = (this.getPropertyInAncestors('pqmProcData') as PqmProcData)
			.cooperating[srcData.pqmPacketId];
		if (cooperating) {

			super.muBindData({
				cooperating: cooperating.map(a => ({ ...a, ticket: a })),
			})
		}

		this.muVisible(!!conditions, 'conditionsContainer');

		const fieldClass = PqmFieldRegister.getClassFor(srcData.paramType, srcData.control);

		this.fieldWidget = fieldClass
			? this.muWidgetFromTemplate(
				{ html: "<div></div>", classType: fieldClass },
				"pInput",
				srcData
			) as unknown as BasePqmFieldValue
			: null;

		if (this.fieldWidget) this.fieldWidget.onChange = () => this.update();
		sleepPromise(100).then(() => this.update());
		this.setDisabled(this.disabled);
		this.setRejectVisible(this.packets.packetsData.isInput);
	}

	markCompletion() {
		this.requireCompletion = true;
		this.update();
	}

	update() {
		this.muVisible(
			!!this.pqmPacketData.hasCheckbox,
			[ "lIsComplete", "!isCompleteIndicator" ]
		);
		this.muVisible(!this.pqmPacketData.paramType, "shiftDetails");
		changeClassStartsWith(this.ui.label.classList, 'col-sm-', !this.pqmPacketData.paramType ? '12' : '3');

		changeIconBefore(
			this.ui.isCompleteIndicator,
			this.pqmPacketData.optional
				? "checked-blue"
				: (this.fieldWidget?.isFilled() ? "checked-on" : "checked-off")
		);

		const isInput = this.packets.packetsData.isInput;
		this.ui.reject.disabled = isInput ? this.requireCompletion : !this.requireCompletion;

		this.ui.lReject.title = isInput ? (
			this.ui.reject.disabled
				? "Tato hodnota vyžaduje doplnění"
				: "Klinutím můžete označít tuto hodnotu jako chybnout a vyžádát její doplnění"
		) : (
			this.ui.reject.disabled
				? ""
				: "Tato hodnota vyžaduje doplnění, až doplníte údaje, kliknutím označíte jako doplněnou. Nezapomeňte uložit změny."
		);
		this.getPropertyInAncestors('ticketId')
		this.muVisible(!!this.getPropertyInAncestors('ticketId'), 'lReject');
	}

	checkIsComplete(checked = true) {
		if (this.pqmPacketData.hasCheckbox) this.ui.isComplete.checked = checked;
	}

	isComplete(): boolean {
		return this.pqmPacketData.hasCheckbox
			? this.ui.isComplete.checked
			: (this.fieldWidget?.isFilled() ?? true);
	}

	getFieldData(): PqmProcDataField {
		return {
			isComplete: this.ui.isComplete.style.display ? null : this.ui.isComplete.checked,
			requireCompletion: this.ui.reject.checked,
			value: this.fieldWidget?.getValue(),
		}
	}

	setFieldData(item: PqmProcDataField): void {
		if (typeof item.isComplete === "boolean") this.ui.isComplete.checked = item.isComplete;
		if (this.fieldWidget) this.fieldWidget.setValue(item.value);
		this.requireCompletion = item.requireCompletion || false;
		this.ui.reject.checked = item.requireCompletion ?? false;

		this.update();
	}

	async afterSave(res: PqmProcData) {
		return this.fieldWidget
			? this.fieldWidget.afterSave(res)
			: null ;
	}
}